import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { ArrowRight, ArrowLeft, Check } from 'lucide-react';

export default function Program() {
  const nav = useNavigate();
  const [selected, setSelected] = useState('YOURREGEN12');

  const programs = [
    {
      id: 'YOURREGEN6', months: 6, label: 'YourReGen 6',
      heading: 'Build The Foundation',
      desc: '6 months to lose fat, build strength and establish lasting habits.',
      accent: '#00C8FF',
    },
    {
      id: 'YOURREGEN12', months: 12, label: 'YourReGen 12',
      heading: 'Complete Transformation',
      desc: '12 months to create a stronger, leaner and healthier lifestyle for life.',
      accent: '#65A30D', popular: true,
    },
  ];

  const handleContinue = () => {
    localStorage.setItem('regen_selected_program', selected);
    nav('/register');
  };

  return (
    <div className="min-h-screen flex flex-col px-6 pt-12 pb-10 max-w-2xl mx-auto">
      <button data-testid="back-btn" onClick={() => nav(-1)} className="text-muted-foreground hover:text-foreground inline-flex items-center gap-2 text-sm"><ArrowLeft className="w-4 h-4" /> Back</button>
      <div className="mt-8">
        <div className="label-mini text-[#00C8FF]">Choose Your Path</div>
        <h1 className="font-display font-black text-4xl md:text-5xl mt-3 tracking-tight">Choose Your Program</h1>
      </div>

      <div className="mt-8 space-y-4 flex-1">
        {programs.map(p => (
          <button
            key={p.id}
            onClick={() => setSelected(p.id)}
            data-testid={`program-${p.id}`}
            className={`w-full text-left regen-card-elevated p-6 transition-all relative ${
              selected === p.id ? 'ring-2 scale-[1.01]' : 'opacity-75'
            }`}
            style={{ '--tw-ring-color': p.accent }}
          >
            {p.popular && <div className="absolute -top-2.5 right-5 pill bg-[var(--c-green)] text-[#081726] font-bold text-[10px]">MOST POPULAR</div>}
            <div className="flex items-start gap-4">
              <div className="w-14 h-14 rounded-2xl flex items-center justify-center font-display font-black text-2xl" style={{ background: `${p.accent}1a`, color: p.accent }}>
                {p.months}
              </div>
              <div className="flex-1">
                <div className="font-display font-bold text-2xl">{p.label}</div>
                <div className="text-base mt-1 font-medium" style={{ color: p.accent }}>{p.heading}</div>
                <div className="text-sm text-muted-foreground mt-1.5 leading-relaxed">{p.desc}</div>
              </div>
              {selected === p.id && (
                <div className="w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0" style={{ background: p.accent, color: '#081726' }}>
                  <Check className="w-4 h-4" strokeWidth={3} />
                </div>
              )}
            </div>
          </button>
        ))}
      </div>

      <Button onClick={handleContinue} data-testid="continue-program-btn" className="mt-8 h-14 w-full bg-[#00C8FF] hover:bg-[#00C8FF]/90 text-[#081726] font-semibold rounded-2xl">
        Continue <ArrowRight className="ml-2 w-4 h-4" />
      </Button>
    </div>
  );
}
